import React from 'react';
import '../home.css';

const plans = [
  // {
  //   name: "Free",
  //   subtitle: "Perfect for getting started",
  //   price: "₹0",
  //   priceUnit: "/forever",
  //   features: [
  //     "Access to 5 courses",
  //     "Community access",
  //     "Basic certificate",
  //     "Email support",
  //     "Learning resources"
  //   ],
  //   btn: "Get Started",
  //   highlight: false
  // },
  {
    name: "Pro",
    subtitle: "Most popular for learners",
    price: "₹2,999",
    priceUnit: "/per month",
    features: [
      "Access to all courses",
      "2 mentor hours/month",
      "Internship eligibility",
      "Pro certificate",
      "Priority support",
      "Career guidance",
      "Portfolio reviews"
    ],
    btn: "Choose Plan",
    highlight: true,
    badge: "Most Popular"
  },
  {
    name: "Infinity",
    subtitle: "For serious professionals",
    price: "₹9,999",
    priceUnit: "/per month",
    features: [
      "Everything in Pro",
      "Unlimited mentor hours",
      "Guaranteed internship",
      "Premium certificate",
      "1:1 career coaching",
      "Job placement support",
      "Lifetime course access",
      "Exclusive workshops"
    ],
    btn: "Choose Plan",
    highlight: false
  }
];

const tick = <span className="path-feature-icon">✔</span>;

function Path_Page() {
  return (
    <div className="bg-white pt-3 pb-12">
      <div className="path-title font-black">
        Choose Your <span className="path-highlight">Path</span>
      </div>
      <div className="path-desc">
        Flexible plans that grow with your ambitions
      </div>
      <div className="path-cards-row">
        {plans.map((plan, idx) => (
          <div className="path-card" key={plan.name}>
            {plan.highlight && <span className="path-popular-badge">{plan.badge}</span>}
            <div className="path-plan-title">{plan.name}</div>
            <div className="path-plan-subtitle">{plan.subtitle}</div>
            <div className="path-price-row">
              <span className="path-price">{plan.price}</span>
              <span className="path-price-unit">{plan.priceUnit}</span>
            </div>
            <button className={plan.highlight ? "path-action-btn-selected" : "path-action-btn"}>
              {plan.btn}
            </button>
            <div className="path-feature-list">
              {plan.features.map(f => (
                <div className="path-feature-item" key={f}>
                  {tick}
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Path_Page;
